module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/4e08c5c29f8c606a1f9bcccf85e492b8.png";